import { useQuery } from '@tanstack/react-query';
import { repositoryFactory, DataSourceStrategy, CacheStrategy, } from '@rammetec/data-access';
import { ORGANIZATION_READ } from '@vectorhub/domain';
/**
 * Fetches org name + abbreviation for a list of org IDs.
 * Returns a Map<orgId, OrgLabel>. Falls back to orgId when Firestore data is missing.
 */
export function useOrgLabels(orgIds) {
    const { data } = useQuery({
        queryKey: ['orgLabels', [...orgIds].sort()],
        queryFn: async () => {
            const map = new Map();
            await Promise.all(orgIds.map(async (orgId) => {
                try {
                    const repo = await repositoryFactory.getRepository(`org`, ORGANIZATION_READ, DataSourceStrategy.Firestore, CacheStrategy.InMemory);
                    const org = await repo.getById(orgId);
                    map.set(orgId, {
                        name: org?.name ?? orgId,
                        abbreviation: org?.abbreviation ?? undefined,
                    });
                }
                catch {
                    map.set(orgId, { name: orgId });
                }
            }));
            return map;
        },
        enabled: orgIds.length > 0,
        staleTime: 10 * 60 * 1000,
    });
    return data ?? new Map(orgIds.map((id) => [id, { name: id }]));
}
//# sourceMappingURL=useOrgNames.js.map